import { render, staticRenderFns } from "./csrs.vue?vue&type=template&id=24c4b3f7&scoped=true&"
import script from "./csrs.vue?vue&type=script&lang=js&"
export * from "./csrs.vue?vue&type=script&lang=js&"
import style0 from "./csrs.vue?vue&type=style&index=0&id=24c4b3f7&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24c4b3f7",
  null
  
)

export default component.exports